/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */



jQuery(document).on("click", ".readMore,.readLess", function() {
//         jQuery(".less_text").toggle("fold", 1000 );
jQuery(".less_text").fadeToggle(500);
if(jQuery(this).hasClass("readMore")){
 jQuery(this).removeClass("readMore");
 jQuery(this).addClass("readLess");
 jQuery(this).text("Read Less");

}else{

 jQuery(this).removeClass("readLess");
 jQuery(this).addClass("readMore");
 jQuery(this).text("Read More");
}
        
    });


jQuery(document).on("click", ".readMoreee,.readLessss", function() {
        jQuery(".moreeee").fadeToggle(500);
if(jQuery(this).hasClass("readMoreee")){
 jQuery(this).removeClass("readMoreee");
 jQuery(this).addClass("readLessss");
 jQuery(this).text("Read Less");

}else{

 jQuery(this).removeClass("readLessss");
 jQuery(this).addClass("readMoreee");
 jQuery(this).text("Read More");
}
        
    });





 

jQuery(document).ready(function(){
  

  jQuery( ".read_sect" ).on("click",function() {
 jQuery(".expannnn_content").slideToggle(600);
});
var faqqss=jQuery(".description .video_section").html();
jQuery(".video_sec").html(faqqss);

  
  var faqq=jQuery(".description .Faqforproduct").html();
jQuery(".Faqforproductss").html(faqq);
  
   var rttt=jQuery(".expandable").html();

jQuery("  .expandable").remove();
jQuery(".expannnn_content").html(rttt);

});


jQuery(document).ready(function(){
  jQuery(".Faqforproductss p").hide();
jQuery(".faq_sec h3").on("click",function(){

  if(jQuery(this).hasClass('active')){
    jQuery(this).parent().find("p").slideUp();
     jQuery(this).removeClass('active');

  }else{
jQuery(this).addClass("active");
jQuery(this).parent().find("p").slideToggle(600);
  
  }
});
jQuery( ".close-expandable" ).on("click",function() {
 jQuery(".expannnn_content").slideUp(800);
});
  
});


$(document).ready(function(){
  $('.Collapsible__Content').hide();
    
  $('button.Collapsible__Button').click(function() {
    if ($(this).hasClass("active")) {
      $(this).removeClass("active").find(".answer").slideUp();
    } else {
      $(".Collapsible__Button .answer").slideUp();
      $(".Collapsible__Button").removeClass("active");
      $(this).addClass("active").find(".answer").slideDown();
    }
    return false;
  });
  
});
$(document).ready(function(){
var newWindowWidth = $(window).width();
        if (newWindowWidth < 481) {
            jQuery('.Faqforproductss').insertAfter('.Product__Tabs');
        }
          
});

